<template>
  <rect width="16" height="16" fill="black" fill-opacity="0.01" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M10.4243 3.07574C10.1899 2.84142 9.81005 2.84142 9.57574 3.07574L5.07574 7.57574C4.84142 7.81005 4.84142 8.18995 5.07574 8.42426L9.57574 12.9243C9.81005 13.1586 10.1899 13.1586 10.4243 12.9243C10.6586 12.6899 10.6586 12.3101 10.4243 12.0757L6.34853 8L10.4243 3.92426C10.6586 3.68995 10.6586 3.31005 10.4243 3.07574Z"
    fill="currentColor" />
</template>
